import { Component, OnInit } from '@angular/core';
import { ColorScssService } from '../shared/service/color-scss.service'

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss']
})
export class ShopComponent implements OnInit {

  constructor(public colorPicker: ColorScssService) { }

  ngOnInit() {
    // this.colorPicker.setColorScheme('inner-page');
  }

}
